import { render, staticRenderFns } from "./ConnectInstagramWidget.vue?vue&type=template&id=f64712e0&scoped=true&"
import script from "./ConnectInstagramWidget.vue?vue&type=script&lang=js&"
export * from "./ConnectInstagramWidget.vue?vue&type=script&lang=js&"
import style0 from "./ConnectInstagramWidget.vue?vue&type=style&index=0&id=f64712e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64712e0",
  null
  
)

export default component.exports